var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    className: "wd-icon-media-topics wd-icon",
    focusable: "false",
    role: "presentation",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    className: "wd-icon-container"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 5h5v5H5V5zm0 9h5v5H5v-5zm9-9h5v5h-5V5zm0 9h5v5h-5v-5z",
    className: "wd-icon-background",
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 4.503C4 4.225 4.233 4 4.503 4h5.994c.278 0 .503.233.503.503v5.994a.508.508 0 0 1-.503.503H4.503A.508.508 0 0 1 4 10.497V4.503zM6 6v3h3V6H6zm-2 7.503c0-.278.233-.503.503-.503h5.994c.278 0 .503.233.503.503v5.994a.508.508 0 0 1-.503.503H4.503A.508.508 0 0 1 4 19.497v-5.994zM6 15v3h3v-3H6zm7-10.497c0-.278.233-.503.503-.503h5.994c.278 0 .503.233.503.503v5.994a.508.508 0 0 1-.503.503h-5.994a.508.508 0 0 1-.503-.503V4.503zM15 6v3h3V6h-3zm-2 7.503c0-.278.233-.503.503-.503h5.994c.278 0 .503.233.503.503v5.994a.508.508 0 0 1-.503.503h-5.994a.508.508 0 0 1-.503-.503v-5.994zM15 15v3h3v-3h-3z",
    className: "wd-icon-fill",
    fill: "#7b858f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedia);
export default __webpack_public_path__ + "static/media/media.823877d3c208e31e290b3ad58308a5d3.svg";
export { ForwardRef as ReactComponent };